<template>
  <div>
    <el-drawer :visible.sync="showDrawer" :with-header="false" size="971px" :modal-append-to-body="false" @close="closeDrawer">
      <div class="drawer-body">
        <el-tabs v-model="activeName">
          <el-tab-pane label="广告详情" name="first"></el-tab-pane>
          <el-tab-pane label="广告数据" name="second"></el-tab-pane>
          <el-tab-pane label="人群分析" name="third"></el-tab-pane>
        </el-tabs>
        <div class="content-body" v-show="activeName === 'first'">
          <div class="info-body">
            <div class="left-content">
              <div class="line">
                <div class="title">投放ID：</div>
                <div class="content" v-text="adv_item.adv_id"></div>
              </div>
              <!-- <div class="line">
                <div class="title">广告样式：</div>
                <div class="content" v-text="uploadData[adv_item.upload_type]"></div>
              </div> -->
              <div class="line">
                <div class="title">推广名称：</div>
                <div class="content" v-text="adv_item.adv_name"></div>
              </div>
              <div class="line">
                <div class="title">物料名称：</div>
                <div class="content" v-text="adv_item.material_name"></div>
              </div>
              <div class="line">
                <div class="title">广告商：</div>
                <div class="content" v-text="company_name"></div>
              </div>
              <!-- <div class="line">
                <div class="title">性别：</div>
                <div class="content" v-text="sex[parseInt(adv_item.get_info.sex)]"></div>
              </div>
              <div class="line">
                <div class="title">广告URL：</div>
                <div class="content" v-text="adv_item.url"></div>
              </div>
              <div class="line">
                <div class="title">投放区域：</div>
                <div class="content" v-text="adv_item.city_names === '' ? '不限' : adv_item.city_names"></div>
              </div>
              <div class="line">
                <div class="title">关键词：</div>
                <div class="content">不限</div>
              </div>
              <div class="line">
                <div class="title">投放方向：</div>
                <div class="content">mobile</div>
              </div>
              <div class="line">
                <div class="title">投放平台：</div>
                <div class="content">
                  <span v-if="adv_item.phone_system.includes('1')">Android,</span>
                  <span v-if="adv_item.phone_system.includes('2')">IOS</span>
                </div>
              </div>
              <div class="line">
                <div class="title">广告内容：</div>
                <div class="content" v-text="adv_item.get_info.title"></div>
              </div>
              <div class="line">
                <div class="title">投放年龄：</div>
                <div class="content">
                  <span v-if="adv_item.get_info.ageTop">不限</span>
                  <span v-else v-for="(item, index) in adv_item.get_info.age" :key="index" v-text="age[parseInt(item)] + ' '"></span>
                </div>
              </div>
              <div class="line">
                <div class="title">广告商简称：</div>
                <div class="content" v-text="adv_item.source"></div>
              </div> -->
              <div class="line">
                <div class="title">预算类型：</div>
                <div class="content" v-text="adv_item.adv_type === 1 ? '日预算' : '总预算'"></div>
              </div>
              <!-- <div class="line">
                <div class="title">网络环境：</div>
                <div class="content">
                  <span v-if="adv_item.get_info.networkTop">不限</span>
                  <span v-else v-for="(item, index) in adv_item.get_info.network" :key="index" v-text="network[parseInt(item)] + ' '"></span>
                </div>
              </div>
              <div class="line">
                <div class="title">网络运营商：</div>
                <div class="content">
                  <span v-if="adv_item.get_info.serviceTop">不限</span>
                  <span v-else v-for="(item, index) in adv_item.get_info.service" :key="index" v-text="service[parseInt(item)] + ' '"></span>
                </div>
              </div> -->
              <div class="line">
                <div class="title">展现频次：</div>
                <div class="content" v-text="adv_item.get_info.read_num_c"></div>
              </div>
              <div class="line">
                <div class="title">展现次数：</div>
                <div class="content" v-text="adv_item.get_info.read_num"></div>
              </div>
              <div class="line">
                <div class="title">点击次数：</div>
                <div class="content" v-text="adv_item.get_info.look_num"></div>
              </div>
            </div>
            <!-- <div class="right-content">
              <div class="top">创意预览：</div>
              <div class="pic-show-layer">
                <div class="one" v-if="adv_item.upload_type === 1">
                  <div class="one-title" v-text="adv_item.get_info.title"></div>
                  <div class="img">
                    <img :src="getImg()" alt="show-logo">
                  </div>
                  <div class="bottom">
                    <div class="left">广告</div>
                    <div class="right" v-text="adv_item.source"></div>
                  </div>
                </div>
                <div class="two" v-if="adv_item.upload_type === 2">
                  <div class="two-img">
                    <img :src="getImg()" alt="show-logo">
                  </div>
                  <div class="right-content">
                    <div class="two-title" v-text="adv_item.get_info.title"></div>
                    <div class="bottom">
                      <div class="left">广告</div>
                      <div class="right" v-text="adv_item.source"></div>
                    </div>
                  </div>
                </div>
                <div class="three" v-if="adv_item.upload_type === 3">
                  <div class="three-title" v-text="adv_item.get_info.title"></div>
                  <div class="center">
                    <img :src="adv_item.pics[0].url" alt="show-logo">
                    <img :src="adv_item.pics[1].url" alt="show-logo">
                    <img :src="adv_item.pics[2].url" alt="show-logo">
                  </div>
                  <div class="bottom">
                    <div class="left">广告</div>
                    <div class="right" v-text="adv_item.source"></div>
                  </div>
                </div>
                <div class="four" v-if="adv_item.upload_type === 4 || adv_item.upload_type === 5">
                  <img :src="getImg()" alt="show-logo">
                </div>
                <div class="three" v-if="adv_item.upload_type === 6">
                  <div class="three-title" v-text="adv_item.get_info.title"></div>
                  <div class="center">
                    <img :src="getImg()" alt="show-logo" style="width: 100%; height: 80px;">
                  </div>
                  <div class="bottom">
                    <div class="left">广告</div>
                    <div class="right" v-text="adv_item.source"></div>
                  </div>
                </div>
                <div class="three" v-if="adv_item.upload_type === 7">
                  <div class="three-title" v-text="adv_item.get_info.title"></div>
                  <div class="center">
                    <img :src="getImg()" alt="show-logo" style="width: 100%; height: 250px;">
                  </div>
                  <div class="bottom">
                    <div class="left">广告</div>
                    <div class="right" v-text="adv_item.source"></div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="info-body" style="display: block">
            <div class="top" style="margin-bottom: 10px">物料信息：</div>
            <div class="left-content" style="padding: 20px;">
              <div class="line">
                <div class="title">物料名称：</div>
                <div class="content" v-text="adv_item.material_name"></div>
              </div>
              <div class="line">
                <div class="title">物料推广语：</div>
                <div class="content" v-text="adv_item.material_desc"></div>
              </div>
              <div class="line">
                <div class="title">物料来源：</div>
                <div class="content" v-text="adv_item.source_id === 1 ? 'WAP' : 'PC'"></div>
              </div>
              <div class="line">
                <div class="title">联网渠道：</div>
                <div class="content" v-text="getNetwork(adv_item).network"></div>
              </div>
              <div class="line">
                <div class="title">运营商：</div>
                <div class="content" v-text="getNetwork(adv_item).carrier"></div>
              </div>
              <div class="line">
                <div class="title">广告类型：</div>
                <div class="content" v-text="getAdvType(adv_item.adv_type)"></div>
              </div>
            </div>
          </div>
          <div class="line-b"></div>
          <div class="bottom-body">
            <div class="top-title" v-if="parseInt(adv_item.adv_type) === 8">物料视频信息</div>
            <div class="imgs" v-if="parseInt(adv_item.adv_type) === 8">
              <video :src="adv_item.video_path" class="avatar video-avatar" controls="controls">
                  您的浏览器不支持视频播放
              </video>
            </div>
            <div class="top-title" v-if="parseInt(adv_item.adv_type) !== 8">物料图片信息</div>
            <div class="imgs" v-if="parseInt(adv_item.adv_type) !== 8">
              <div>
                <img :src="getImg()" style="height: 135px; object-fit: contain;">
              </div>
            </div>
          </div>
        </div>

        <div class="data-body" v-show="activeName === 'second'">
          <div class="top-data">
            <div class="data-item blue">
              <div class="font">曝光量（次）</div>
              <div class="num" v-text="num['read_num']"></div>
            </div>
            <div class="data-item org">
              <div class="font">点击量（次）</div>
              <div class="num" v-text="num['look_num']"></div>
            </div>
            <div class="data-item green">
              <div class="font">点击率</div>
              <div class="num" v-text="num['click_l']"></div>
            </div>
            <div class="data-item zs">
              <div class="font">点击均价（元）</div>
              <div class="num" v-text="num['click_p']"></div>
            </div>
            <div class="data-item red">
              <div class="font">消耗金额（元）</div>
              <div class="num" v-text="num['pay_money']"></div>
            </div>
          </div>
          <div class="make">
            <el-select v-model="value" placeholder="请选择" size="small" @change="getData">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div style="float: right;">
              <el-date-picker v-model="pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
              <el-button type="primary" size="small" @click="getData">查询</el-button>
            </div>
            <div class="charts" style="padding-bottom: 30px;">
              <div id="myChart" :style="{width: '857px', height: '300px'}"></div>
            </div>
          </div>
          <div class="make">
            <el-button type="primary" size="small" @click="exportExcel">下载报表</el-button>
          </div>
          <div class="table">
            <el-table :data="tableData" border style="width: 100%" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
              <el-table-column prop="today" width="" label="时间" align="center"></el-table-column>
              <el-table-column prop="read_num" label="展现数" width="" align="center"></el-table-column>
              <el-table-column prop="look_num" label="点击数" width="" align="center"></el-table-column>
              <el-table-column prop="click_l" label="点击率" width="" align="center"></el-table-column>
              <el-table-column prop="cpc" label="CPC" width="" align="center"></el-table-column>
              <el-table-column prop="cpm" label="CPM" width="" align="center"></el-table-column>
              <el-table-column prop="pay_money" label="消耗(元)" width="" align="center"></el-table-column>
            </el-table>
          </div>
        </div>

        <div class="people-body" v-show="activeName === 'third'">
          <div class="radios">
            <el-radio-group v-model="radio">
              <el-radio :label="index" v-for="(item, index) in radios" :key="index">{{ item }}</el-radio>
            </el-radio-group>
          </div>
          <div class="make">
            <el-button type="primary" size="small" @click="showE">下载报表</el-button>
            <div style="float: right;">
              <el-date-picker v-model="time" type="date" placeholder="选择日期" style="width: 160px; margin-right: 10px;" size="small"></el-date-picker>
              <el-button type="primary" size="small">查询</el-button>
            </div>
          </div>
          <div class="table">
            <el-table :data="tableData2" border style="width: 100%" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
              <el-table-column width="" :label="radios[radio]" align="center">
                <template slot-scope="scope">
                  {{ adv_item.title }}
                </template>
              </el-table-column>
              <el-table-column prop="read" sortable label="展现量" width="" align="center"></el-table-column>
              <el-table-column prop="click" sortable label="点击量" width="" align="center"></el-table-column>
              <el-table-column prop="click_p" sortable label="点击率" width="" align="center"></el-table-column>
              <el-table-column prop="pay" sortable label="消耗" width="" align="center"></el-table-column>
              <el-table-column prop="cpc" sortable label="CPC" width="" align="center"></el-table-column>
              <el-table-column prop="cpm" sortable label="CPM" width="" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  /* global require */
  name: 'drawer',
  data() {
    return {
      showDrawer: false,
      activeName: 'first',
      sex: ['不限', '男', '女'],
      uploadData: ['', '大图', '单图', '三图', '开屏', '新视频', '新大图', '橱窗大图'],
      age: ['', '0-17', '18-24', '25-34', '35-44', '45-54', '55+'],
      network: ['', '2G', '3G', '4G', '5G', 'WIFI'],
      service: ['', '中国联通', '中国电信', '中国移动'],
      radios: ['城市', '时段', '系统', '性别', '年龄', '兴趣爱好', '手机品牌'],
      radio: 0,
      tableData: [
        {
          phone: '17620909963',
          wechatNum: 2,
          status: 1
        }
      ],
      time: '',
      tableData2: [],
      pay_time: [],
      options: [{
        value: '1',
        label: '展现数'
      }, {
        value: '2',
        label: '点击数'
      }, {
        value: '3',
        label: '点击率'
      }, {
        value: '4',
        label: 'CPC'
      }, {
        value: '5',
        label: 'CPM'
      }, {
        value: '6',
        label: '消耗（元）'
      }],
      value: '1',
      num: [],
      company_name: ''
    };
  },
  created() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    this.setTimeInit();
    this.showDrawer = JSON.parse(JSON.stringify(this.drawer));
    this.$nextTick(() => {
      this.getData();
    });
  },
  props: ['drawer', 'adv_item'],
  methods: {
    getAdvType(adv_type) {
      return {
        1: "小图",
        2: "大图",
        3: "组图",
        4: "横幅",
        5: "插屏",
        6: "开屏",
        7: "视频暂停位",
        8: "视频广告位",
      }[adv_type]
    },
    getNetwork(row) {
      return {
        carrier: ['不限', '中国移动', '中国联通', '中国电信'][row.carrier],
        network: ['不限', '2G', '3G', '4G', '5G', 'WIFI'][row.network]
      }
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.pay_time = [today, today];
    },
    exportExcel() {
      const { export_json_to_excel } = require('@/plugin/Export2Excel');
      const tHeader = ['时间', '展现数', '点击数', '点击率', 'CPC', 'CPM', '消耗(元)'];
      const filterVal = ['today', 'read_num', 'look_num', 'click_l', 'cpc', 'cpm', 'pay_money'];
      const list = this.tableData;
      const data = this.formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, this.adv_item.adv_name + '_广告数据');
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    getData() {
      this.$http.post('/trader/data/getTableLists', {
        pay_time: this.pay_time,
        adv_id: this.adv_item.adv_id,
        value: this.value
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.num = res.num;
          const option = {
            xAxis: {
              type: 'category',
              data: res.static.data
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '8%',
              left: '8%',
              right: '2%',
              bottom: '8%'
            },
            tooltip: {
              show: true, // 显示提示框
              trigger: 'axis'
            },
            series: [{
              data: res.static.value,
              type: 'line',
              smooth: true,
              color: '#4cc9f5'
            }]
          };
          const echartsRecords = echarts.init(document.getElementById('myChart'), 'walden');
          echartsRecords.setOption(option);
        }
      });
    },
    getImg() {
      return this.$Config.apiUrl + this.adv_item.pic;
    },
    closeDrawer() {
      this.$emit('close_call_back');
      this.activeName = 'first';
    },
    showE() {
      this.$message.error('未找到数据哟~');
    }
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second') {
        this.$nextTick(() => {
          this.getData();
          if (this.tableData.length <= 0) {

          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped="">
  .drawer-body {
    height: 100%;
    width: 100%;
    padding: 15px 30px;
    .content-body {
      height: calc(100% - 40px);
      overflow-y: auto;
      .info-body {
        display: flex;
        padding: 23px 0 0 35px;
        .left-content {
          width: 454px;
          .line {
            line-height: 22px;
            margin-bottom: 10px;
            display: flex;
            .title {
              width: 85px;
              font-size: 12px;
              color: #999;
            }
            .content {
              width: 325px;
              font-size: 12px;
              color: #333;
              word-break:break-all
            }
          }
        }
        .right-content {
          width: 340px;
          .top {
            font-size: 12px;
            color: #999;
            font-weight: 700;
          }
          .pic-show-layer {
            margin: 21px 0 0 13px;
            .zero {
              width: 342px;
              height: 178px;
              text-align: center;
              border: 1px solid #e1e3e4;
              font-size: 12px;
              color: #999;
              img {
                width: 89px;
                height: 73px;
                margin: 25px 0;
              }
            }
            .one {
              width: 288px;
              height: 213px;
              border: 1px solid #e1e3e4;
              padding: 16px 26px;
              .one-title {
                font-size: 14px;
                color: #333;
                margin-bottom: 5px;
              }
              .img {
                width: 100%;
                img {
                  width: 100%;
                  height: 146px;
                }
              }
            }
            .bottom {
              display: flex;
              justify-content: space-between;
              margin-top: 5px;
              .left {
                border: solid 1px #e3e3e3;
                width: 30px;
                height: 18px;
                border-radius: 3px;
                font-size: 12px;
                line-height: 15px;
                text-align: center;
                color: #999;
              }
              .right {
                font-size: 12px;
                color: #999;
              }
            }
            .two {
              width: 288px;
              height: 75px;
              display: flex;
              padding: 18px 26px;
              border: 1px solid #e1e3e4;
              .two-img {
                width: 100px;
                height: 75px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .right-content {
                width: 178px;
                padding-left: 10px;
                .two-title {
                  font-size: 14px;
                  color: #333;
                  height: 40px;
                  margin-bottom: 15px;
                }
              }
            }
            .three {
              width: 288px;
              padding: 18px 26px;
              border: 1px solid #e1e3e4;
              .three-title {
                font-size: 14px;
                color: #333;
                height: 40px;
                margin-bottom: 10px;
              }
              .center {
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                img {
                  width: 94px;
                  height: 64px;
                }
              }
            }
            .four {
              width: 288px;
              padding: 20px 26px;
              border: 1px solid #e1e3e4;
              overflow: hidden;
              img {
                height: 486px;
                width: 288px;
              }
            }
          }
        }
      }
      .line-b {
        height: 2px;
        background-color: #e2e2e2;
        margin-bottom: 30px;
      }
      .bottom-body {
        .top-title {
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 20px;
        }
        .imgs {
          display: flex;
          margin-bottom: 30px;
          img {
            margin-right: 20px;
          }
        }
      }
    }

    .data-body {
      .top-data {
        display: flex;
        justify-content: space-between;
        margin: 10px 0 25px 0;
        .data-item {
          width: 120px;
          height: 44px;
          padding: 11px 21px;
          color: #fff;
          .font {
            font-size: 12px;
            margin-bottom: 5px;
          }
          .num {
            font-size: 22px;
          }
        }
        .blue {
          background: #4cc9f5;
        }
        .org {
          background: #ffc484;
        }
        .green {
          background: #28d7d2;
        }
        .zs {
          background: #c596f5;
        }
        .red {
          background: #ff749f;
        }
      }
      .table {
        margin-top: 20px;
      }
    }

    .people-body {
      .radios {
        padding: 20px 0;
      }
      .table {
        margin-top: 20px;
      }
    }
  }

</style>
